import {FC, useEffect} from 'react';
import {useApi} from './Auth';
import {sendLog} from './log';

export const GlobalErrorListener: FC = () => {
  const api = useApi();

  useEffect(() => {
    const handleError = async (event: ErrorEvent) => {
      await sendLog(api, {
        errCode: 'js.window.onerror',
        errText: event.error,
        errObj: JSON.stringify(event),
      });
    };
    const handleRejection = async (event: PromiseRejectionEvent) => {
      await sendLog(api, {
        errCode: 'js.unhandledrejection',
        errText: event.reason,
        errObj: JSON.stringify(event),
      });
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, [api]);

  return null;
};
